<template>
  <el-form-item :label="title">
    <el-date-picker v-model="date" type="daterange" start-placeholder="开始日期" range-separator="至" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="DateChange" :key="cascaderkey" ></el-date-picker>
  </el-form-item>
</template>

<script>
import { DefaultSearchDate } from "@/utils";
export default {
  name: "GetDate",
  props:{
    title: {
      type: String,
      default:''
    },
    initDate: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      date: [],
      cascaderkey: 1,
    };
  },
  watch: {
    // date(n) {
    //   if (!n) {
    //     this.$emit("getDate", DefaultSearchDate());
    //   }
    // },
    initDate(val){
      if(val) {
        this.date = val
      }
    }
  },
  methods: {
    DateChange(date) {
      console.log("DateChange()...",date );
      if (date == null) {
        date=[];
        date[0] = ''
        date[1] = ''
      } else {
        date[0] = date[0] + ' 00:00:00';
        date[1] = date[1] + ' 23:59:59';
      }
      this.$emit("getDate", date);
    },
  },
};
</script>